__turbopack_context__.v({
  "boxPickupSections": "HI9ksW_boxPickupSections",
  "orderSectionRow": "HI9ksW_orderSectionRow",
  "sectionInfoText": "HI9ksW_sectionInfoText",
  "selected": "HI9ksW_selected",
  "skeleton": "HI9ksW_skeleton",
});
